// lazy load a view or a component
const lazyLoad = (path) => (() => import(/* webpackChunkName: "[request]" */ `@/${path}.vue`));

export default lazyLoad;
